import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const deleteSpacerMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Delete Space Reservation',
		isVisible: ({ refMap, controller }): boolean => {
			return !controller.readonly && refMap?.panelItem?.item.category?.key === 'spacer';
		},
		onClick: ({ refMap }): void => {
			if (refMap && refMap.panelItem) {
				refMap.panelItemGroup.items.delete(refMap.panelItem.id);
			}
		}
	};
};
